import { ComplementPoPdfVer } from '../../intervenant/models/complementPoPdfVer.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';
import { MapNumberNumberConverter } from 'src/app/core/services/mapper/converters';

export class InfosPoSurface {
    static jsonMap = {
        listPoSurfacePomme: { key: 'listPoSurfacePomme', converter: new MapNumberNumberConverter(), optional: true },
        listPoSurfacePoire: { key: 'listPoSurfacePoire', converter: new MapNumberNumberConverter(), optional: true },
        listComplementPoPdfVer: { key: 'listComplementPoPdfVer', converter: new (ArrayClassConverterFactory.build(ComplementPoPdfVer))(), default: () => [] }
    };

    listPoSurfacePomme: Map<number, number>;
    listPoSurfacePoire: Map<number, number>;
    listComplementPoPdfVer: ComplementPoPdfVer[];
}
